import { Outlet } from 'react-router-dom';
import { Navbar } from './navbar.component';
import { PageExtraProvider } from './page-extra-context';
import ErrorBoundary from '@/components/shared/error-boundary';
import { RouteAnnouncer } from './route-announcer.component';
import { MfaGracePeriodBannerComponent } from '@/features/auth';

/**
 * Root Layout Component
 * Renders navbar + main content area with Outlet
 */
export function RootLayout() {
  return (
    <div className="bg-background flex min-h-screen flex-col">
      {/* Skip navigation — visible on focus only */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[200] focus:top-2 focus:left-2 focus:rounded focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:shadow-md focus:ring-2 focus:ring-ring focus:outline-none"
      >
        Skip to main content
      </a>
      <RouteAnnouncer />
      <Navbar />
      <MfaGracePeriodBannerComponent />
      <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
        <div className="mx-auto max-w-6xl px-4 py-6">
          <PageExtraProvider>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </PageExtraProvider>
        </div>
      </main>
    </div>
  );
}
